import api from "../api/api"; // Caminho correto para api.js
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const producaoService = {

    // ========================================
    // 🆕 MÉTODOS PARA O DASHBOARD DE PRODUÇÃO
    // ========================================

    /**
     * 📋 BUSCAR TODAS AS ORDENS PARA O DASHBOARD
     */
    async buscarTodasOrdens(filtros = {}) {
        try {
                ('🔍 Buscando todas as ordens com filtros:', filtros);

            let url = `${BASE_URL}/dashboard-producao/ordens`;
            const params = new URLSearchParams();

            // Adicionar filtros se existirem
            if (filtros.status && filtros.status.length > 0) {
                params.append('status', filtros.status.join(','));
            }
            if (filtros.apenas_atrasadas) {
                params.append('apenas_atrasadas', '1');
            }
            if (filtros.apenas_urgentes) {
                params.append('apenas_urgentes', '1');
            }
            if (filtros.setor) {
                params.append('setor', filtros.setor);
            }
            if (filtros.cliente) {
                params.append('cliente', filtros.cliente);
            }

            if (params.toString()) {
                url += '?' + params.toString();
            }

//            console.log('📡 URL da requisição:', url);
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
                //console.log('✅ Ordens carregadas:', response.data.ordens?.length || 0);
                return {
                    status: response.data.status || 'sucesso',
                    ordens: response.data.ordens || [],
                    total: response.data.total || 0,
                    resumo: response.data.resumo || {},
                    estatisticas: response.data.estatisticas || {}
                };
            } else {
                throw new Error('Resposta inválida do servidor');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar ordens:', error);
            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar ordens',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 👥 BUSCAR EQUIPE POR ORDEM
     */
    async buscarEquipePorOrdem() {
        try {
            //console.log('👥 Buscando equipe por ordem...');

            const url = `${BASE_URL}/dashboard-producao/equipe-por-ordem`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Equipe por ordem carregada');
                return {
                    status: response.data.status || 'sucesso',
                    ordens: response.data.ordens || [],
                    total: response.data.total || 0
                };
            } else {
                throw new Error('Erro ao buscar equipe por ordem');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar equipe por ordem:', error);
            return {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar equipe por ordem',
                ordens: [],
                total: 0
            };
        }
    },

    // ========================================
    // 📅 MÉTODOS DE PLANEJAMENTO SEMANAL
    // ========================================

    /**
     * 🔍 BUSCAR ORDENS DISPONÍVEIS PARA PLANEJAMENTO COM SETORES
     */
    async buscarOrdensDisponiveis(chaveSemana = null) {
        try {
           // console.log('🔍 Buscando ordens disponíveis com setores...');

            let url = `${BASE_URL}/planejamento-semanal/ordens-disponiveis`;
            const params = new URLSearchParams();

            if (chaveSemana) {
                params.append('semana_excluir', chaveSemana);
            }

            if (params.toString()) {
                url += '?' + params.toString();
            }

           // console.log('📡 URL da requisição:', url);
            const response = await api.get(url);

           // console.log('✅ Ordens com setores carregadas:', response.data.ordens?.length || 0);

            return response.data;
        } catch (error) {
            console.error('❌ Erro ao buscar ordens disponíveis:', error);
            return {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar ordens disponíveis',
                ordens: []
            };
        }
    },

    /**
     * 📅 BUSCAR PLANEJAMENTO DE UMA SEMANA
     */
    async buscarPlanejamentoSemana(chaveSemana) {
        try {
           // console.log('📅 Buscando planejamento da semana:', chaveSemana);

            const url = `${BASE_URL}/planejamento-semanal/planejamento/${chaveSemana}`;
            const response = await api.get(url);

            if (response.status === 200) {
               // console.log('✅ Planejamento encontrado');
                return {
                    status: 'sucesso',
                    planejamento: response.data.planejamento || response.data,
                    semana: chaveSemana
                };
            } else {
                throw new Error('Planejamento não encontrado');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar planejamento:', error);

            if (error.response?.status === 404) {
               // console.log('📝 Planejamento não existe, retornando estrutura vazia');
                return {
                    status: 'sucesso',
                    planejamento: null,
                    semana: chaveSemana
                };
            }

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar planejamento',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 💾 SALVAR PLANEJAMENTO SEMANAL
     */
    async salvarPlanejamentoSemanal(dadosAgendamento) {
        try {
           // console.log('💾 Salvando planejamento semanal:', dadosAgendamento);

            const url = `${BASE_URL}/planejamento-semanal/salvar`;
            const response = await api.post(url, dadosAgendamento);

            //console.log('✅ Planejamento salvo');

            return response.data;
        } catch (error) {
            console.error('❌ Erro ao salvar planejamento:', error);
            return {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao salvar planejamento'
            };
        }
    },

    /**
     * 💾 SALVAR PLANEJAMENTO DE SEMANA
     */
    async salvarPlanejamentoSemana(planejamento) {
        try {
           // console.log('💾 Salvando planejamento semanal:', planejamento);

            const url = `${BASE_URL}/planejamento-semanal`;
            const response = await api.post(url, planejamento);

            if (response.status === 200 || response.status === 201) {
               // console.log('✅ Planejamento salvo com sucesso');
                return {
                    status: 'sucesso',
                    message: 'Planejamento salvo com sucesso',
                    data: response.data
                };
            } else {
                throw new Error('Erro ao salvar planejamento');
            }
        } catch (error) {
            console.error('❌ Erro ao salvar planejamento:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao salvar planejamento',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📊 ANALISAR CAPACIDADE DIA/SETOR
     */
    async analisarCapacidadeDiaSetor(data, setorId, ordemId = null) {
        try {
           // console.log('📊 Analisando capacidade:', { data, setorId, ordemId });

            const payload = {
                data: data,
                setor_id: setorId
            };

            if (ordemId) {
                payload.ordem_id = ordemId;
            }

            const url = `${BASE_URL}/planejamento-semanal/analisar-capacidade`;
            const response = await api.post(url, payload);

            if (response.status === 200 && response.data) {
               // console.log('✅ Análise de capacidade concluída');
                return response.data;
            } else {
                throw new Error('Erro ao analisar capacidade');
            }
        } catch (error) {
            console.error('❌ Erro ao analisar capacidade:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao analisar capacidade',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 💾 SALVAR PLANEJAMENTO DIA/SETOR
     */
    async salvarPlanejamentoDiaSetor(ordemId, setorId, data, quantidade = 0, forcarSobrecarga = false) {
        try {
           // console.log('💾 Salvando planejamento:', { ordemId, setorId, data, quantidade, forcarSobrecarga });

            const payload = {
                ordem_id: ordemId,
                setor_id: setorId,
                data: data,
                quantidade: quantidade,
                forcar_sobrecarga: forcarSobrecarga
            };

            const url = `${BASE_URL}/planejamento-semanal/salvar`;
            const response = await api.post(url, payload);

            if (response.status === 200 && response.data) {
               // console.log('✅ Planejamento salvo com sucesso');
                return response.data;
            } else {
                throw new Error('Erro ao salvar planejamento');
            }
        } catch (error) {
            console.error('❌ Erro ao salvar planejamento:', error);

            // Se for aviso de capacidade, retornar o aviso
            if (error.response?.status === 200 && error.response?.data?.status === 'aviso_capacidade') {
                return error.response.data;
            }

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao salvar planejamento',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📅 BUSCAR DASHBOARD DO DIA
     */
    async buscarDashboardDia(data) {
        try {
           // console.log('📅 Buscando dashboard do dia:', data);

            const url = `${BASE_URL}/planejamento-semanal/dashboard-dia/${data}`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Dashboard do dia carregado');
                return response.data;
            } else {
                throw new Error('Erro ao buscar dashboard do dia');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar dashboard do dia:', error);

            // Se não tem dados para o dia, retornar estrutura vazia
            if (error.response?.status === 404) {
                return {
                    status: 'sucesso',
                    data_dashboard: data,
                    resumo_por_setor: [],
                    estatisticas_dia: {
                        total_ordens: 0,
                        total_setores_utilizados: 0,
                        capacidade_media_utilizada: 0
                    }
                };
            }

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar dashboard do dia',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📊 BUSCAR MÉTRICAS DO DASHBOARD
     */
    async buscarMetricasDashboard() {
        try {
            //console.log('📊 Buscando métricas do dashboard...');

            const url = `${BASE_URL}/dashboard-producao/metricas`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Métricas carregadas');
                return {
                    status: response.data.status || 'sucesso',
                    metricas: response.data.metricas || {},
                    kpis: response.data.kpis || {},
                    alertas: response.data.alertas || [],
                    tendencias: response.data.tendencias || {}
                };
            } else {
                throw new Error('Erro ao buscar métricas');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar métricas:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar métricas',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 🏭 BUSCAR SALDOS POR ORDEM (SETORES DIPONÍVEIS)
     */
    async buscarSaldosPorOrdem(ordemId) {
        try {
           // console.log('🏭 Buscando saldos/setores da ordem:', ordemId);

            const url = `${BASE_URL}/planejamento-semanal/saldos-por-ordem/${ordemId}`;
           // console.log('📡 URL da requisição:', url);

            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Saldos/Setores carregados:', response.data);
                return {
                    status: 'sucesso',
                    data: response.data
                };
            } else {
                throw new Error('Dados de saldos não encontrados');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar saldos por ordem:', error);

            return {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar saldos da ordem',
                data: { saldos: [] }
            };
        }
    },

    /**
     * 🚨 BUSCAR ALERTAS DO SISTEMA
     */
    async buscarAlertas() {
        try {
           // console.log('🚨 Buscando alertas...');

            const url = `${BASE_URL}/dashboard-producao/alertas`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Alertas carregados:', response.data.alertas?.length || 0);
                return {
                    status: response.data.status || 'sucesso',
                    alertas: response.data.alertas || [],
                    total_alertas: response.data.total_alertas || 0,
                    alertas_por_tipo: response.data.alertas_por_tipo || {}
                };
            } else {
                throw new Error('Erro ao buscar alertas');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar alertas:', error);
            return {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar alertas',
                alertas: [],
                total_alertas: 0
            };
        }
    },

    /**
     * 🏭 BUSCAR DASHBOARD COMPLETO
     */
    async buscarDashboardCompleto() {
        try {
           // console.log('🏭 Buscando dashboard completo...');

            const url = `${BASE_URL}/dashboard-producao/dashboard-completo`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Dashboard completo carregado');
                return {
                    status: response.data.status || 'sucesso',
                    dashboard: response.data.dashboard || {},
                    timestamp: response.data.timestamp,
                    data_atual: response.data.data_atual
                };
            } else {
                throw new Error('Erro ao buscar dashboard completo');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar dashboard completo:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar dashboard',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 🏭 BUSCAR CAPACIDADE DE UM SETOR ESPECÍFICO
     */
    async buscarCapacidadeSetor(setorId) {
        try {
           // console.log('🏭 Buscando capacidade do setor:', setorId);

            const url = `${BASE_URL}/dashboard-producao/setor/${setorId}/capacidade-atual`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Capacidade do setor carregada');
                return {
                    status: response.data.status || 'sucesso',
                    ...response.data,
                    setor_id: setorId
                };
            } else {
                throw new Error('Erro ao buscar capacidade do setor');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar capacidade do setor:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar capacidade',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 👥 BUSCAR EQUIPE DE UM SETOR
     */
    async buscarEquipeSetor(setorId) {
        try {
           // console.log('👥 Buscando equipe do setor:', setorId);

            const url = `${BASE_URL}/dashboard-producao/setor/${setorId}/equipe`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Equipe do setor carregada');
                return {
                    status: response.data.status || 'sucesso',
                    setor: response.data.setor || {},
                    equipe: response.data.equipe || {},
                    funcionarios: response.data.funcionarios || [],
                    estatisticas_setor: response.data.estatisticas_setor || {}
                };
            } else {
                throw new Error('Erro ao buscar equipe do setor');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar equipe do setor:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar equipe',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 👤 BUSCAR DETALHES DE UM FUNCIONÁRIO
     */
    async buscarDetalhesFuncionario(funcionarioId) {
        try {
           // console.log('👤 Buscando detalhes do funcionário:', funcionarioId);

            const url = `${BASE_URL}/dashboard-producao/funcionario/${funcionarioId}/detalhes`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
               // console.log('✅ Detalhes do funcionário carregados');
                return {
                    status: response.data.status || 'sucesso',
                    funcionario: response.data.funcionario || {},
                    estatisticas_30_dias: response.data.estatisticas_30_dias || {},
                    historico_recente: response.data.historico_recente || [],
                    performance: response.data.performance || {}
                };
            } else {
                throw new Error('Erro ao buscar detalhes do funcionário');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar detalhes do funcionário:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar funcionário',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📈 CALCULAR PREVISÃO DE PRODUÇÃO
     */
    async calcularPrevisaoProducao(setorId, dados) {
        try {
            //console.log('📈 Calculando previsão de produção:', setorId, dados);

            const url = `${BASE_URL}/dashboard-producao/setor/${setorId}/previsao-producao`;
            const response = await api.post(url, dados);

            if (response.status === 200 && response.data) {
                //console.log('✅ Previsão calculada');
                return {
                    status: response.data.status || 'sucesso',
                    previsao: response.data.previsao || {}
                };
            } else {
                throw new Error('Erro ao calcular previsão');
            }
        } catch (error) {
            console.error('❌ Erro ao calcular previsão:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao calcular previsão',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📊 BUSCAR CAPACIDADE GERAL DE TODOS OS SETORES
     */
    async buscarCapacidadeGeral() {
        try {
            //console.log('📊 Buscando capacidade geral...');

            const url = `${BASE_URL}/dashboard-producao/capacidade-geral`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
//                console.log('✅ Capacidade geral carregada');
                return {
                    status: response.data.status || 'sucesso',
                    ...response.data
                };
            } else {
                throw new Error('Erro ao buscar capacidade geral');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar capacidade geral:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar capacidade',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📋 BUSCAR RELATÓRIO COMPLETO DE CAPACIDADE
     */
    async buscarRelatorioCapacidade(setorId) {
        try {
           // console.log('📋 Buscando relatório de capacidade:', setorId);

            const url = `${BASE_URL}/dashboard-producao/setor/${setorId}/relatorio-capacidade`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
                //console.log('✅ Relatório de capacidade carregado');
                return {
                    status: response.data.status || 'sucesso',
                    relatorio: response.data.relatorio || {}
                };
            } else {
                throw new Error('Erro ao buscar relatório');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar relatório:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar relatório',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 💾 SALVAR PRIORIZAÇÃO DAS ORDENS
     */
    async salvarPriorizacaoOrdens(priorizacao, usuario, observacao) {
        try {
           // console.log('💾 Salvando priorização de ordens...');

            // ✅ VALIDAR DADOS ANTES DE ENVIAR
            if (!Array.isArray(priorizacao) || priorizacao.length === 0) {
                throw new Error('Lista de priorização não pode estar vazia');
            }

            // ✅ DADOS CORRETOS PARA O BACKEND
            const dadosParaEnvio = {
                priorizacao: priorizacao,
                usuario_id: usuario,           // ✅ CORRIGIDO: era 'usuario_alteracao'
                motivo: observacao             // ✅ CORRIGIDO: era 'observacao'
            };

            // console.log('📋 Dados a serem enviados:', {
            //     total_ordens: priorizacao.length,
            //     usuario_id: usuario,
            //     motivo: observacao,
            //     primeira_ordem: priorizacao[0],
            //     ultima_ordem: priorizacao[priorizacao.length - 1]
            // });

            // ✅ ROTA CORRETA E MÉTODO HTTP CORRETO
            const response = await api.post('/dashboard-producao/priorizacao', dadosParaEnvio);

            if (response.status === 200 && response.data) {
               // console.log('✅ Priorização salva com sucesso');
                //console.log('📊 Resultado:', response.data);

                return {
                    status: response.data.status || 'sucesso',
                    message: response.data.message || 'Priorização salva com sucesso',
                    total_alteradas: response.data.total_alteradas || 0,
                    data: response.data
                };
            } else {
                throw new Error('Resposta inválida do servidor');
            }
        } catch (error) {
            console.error('❌ Erro ao salvar priorização:', error);
            console.error('📋 Response completo:', error.response?.data);
            console.error('📋 Status da resposta:', error.response?.status);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao salvar priorização',
                code: error.response?.status || 500,
                details: error.response?.data || null
            };
        }
    },

    // ========================================
    // 📄 MÉTODOS DE EXPORTAÇÃO E SINCRONIZAÇÃO
    // ========================================

    async exportarAnaliseDetalhada(idOrdem) {
        try {
           // console.log('📄 Exportando análise da ordem:', idOrdem);

            const url = `${BASE_URL}/ordens-producao/${idOrdem}/exportar-analise`;
            const response = await api.get(url, {
                responseType: 'blob'
            });

            return response;
        } catch (error) {
            console.error('❌ Erro ao exportar análise:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao exportar análise',
                code: error.response?.status || 500
            };
        }
    },

    async sincronizarDados() {
        try {
           // console.log('🔄 Sincronizando dados...');

            const url = `${BASE_URL}/dashboard/sincronizar`;
            const response = await api.post(url);

            if (response.status === 200) {
               // console.log('✅ Dados sincronizados');
                return {
                    status: 'sucesso',
                    message: 'Dados sincronizados com sucesso',
                    timestamp: response.data.timestamp || new Date()
                };
            } else {
                throw new Error('Erro ao sincronizar dados');
            }
        } catch (error) {
            console.error('❌ Erro ao sincronizar:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao sincronizar dados',
                code: error.response?.status || 500
            };
        }
    },

    // ========================================
    // 🏭 MÉTODOS EXISTENTES DE PRODUÇÃO
    // ========================================

    async fetchLiberacoes() {
        try {
            const url = `${BASE_URL}/liberacao-producao-funcionario`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
                return response.data;
            } else {
                throw new Error("Erro ao obter as liberações de produção.");
            }
        } catch (error) {
            handleError(error, "Erro ao obter as liberações de produção.");
        }
    },

    async buscarProducaoPorIdOrdem(idOrdem) {
        try {
            const url = `${BASE_URL}/movimentacao-producao/saldo-por-id-ordem/${idOrdem}`;
          //  console.log('URL da requisição:', url);

            const response = await api.get(url);
           // console.log('Resposta da API:', response);

            if (response.status === 200 && response.data) {
               // console.log('Dados retornados:', response.data);
                return response.data;
            } else {
                const errorMsg = response.data?.message || 'Erro ao buscar a produção';
                console.error('Erro na resposta da API:', errorMsg);
                throw new Error(errorMsg);
            }
        } catch (error) {
            console.error('Erro na requisição:', error);
            handleError(error, "Erro ao buscar a produção.");
            throw error;
        }
    },

    // ✅ NOVO: Endpoint otimizado para listagem rápida
    async fetchLiberacoesPorFuncionarioResumo(idFuncionario) {
        try {
            const url = `${BASE_URL}/liberacao-funcionario/${idFuncionario}/resumo`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
                return response.data;
            } else {
                throw new Error("Erro ao obter as liberações de produção.");
            }
        } catch (error) {
            handleError(error, "Erro ao obter as liberações de produção.");
        }
    },

    // ✅ Endpoint completo (para quando precisar de todos os dados)
    async fetchLiberacoesPorFuncionario(idFuncionario) {
        try {
            const url = `${BASE_URL}/liberacao-funcionario/${idFuncionario}`;
            const response = await api.get(url);

            if (response.status === 200 && response.data) {
                return response.data;
            } else {
                throw new Error("Erro ao obter as liberações de produção.");
            }
        } catch (error) {
            handleError(error, "Erro ao obter as liberações de produção.");
        }
    },

    async registrarProducao(dadosProducao) {
        try {
            if (dadosProducao.usuario_cadastro) {
                dadosProducao.usuario_cadastro = parseInt(dadosProducao.usuario_cadastro, 10) || 0;
            }

            const url = `${BASE_URL}/movimentacao-producao`;
            const response = await api.post(url, dadosProducao);

            if (response && response.data) {
                if (response.status === 'saldo') {
                    return response;
                } else if (response.status === 'erro') {
                   // console.log('Detectado erro na resposta do servidor:', response.data.mensagem);
                    const error = new Error(response.data.mensagem || 'Erro ao registrar produção');
                    error.response = {
                        status: 422,
                        data: response.data
                    };
                    throw error;
                }

                return response.data;
            } else {
                throw new Error("Resposta da API inválida.");
            }
        } catch (error) {
            console.error("Erro ao registrar produção:", error);

            if (error.isSaldoError) {
             //   console.log('Propagando erro de saldo já tratado');
                throw error;
            }

            if (error.response?.status === 422) {
               // console.log('Erro 422 detectado:', error.response.data);

                if (error.response.data?.status === 'saldo') {
                    const saldoError = new Error(error.response.data.mensagem || 'Saldo insuficiente');
                    saldoError.isSaldoError = true;
                    saldoError.response = error.response;
                    throw saldoError;
                }

                throw error;
            }

            throw new Error(error.message || 'Erro ao registrar produção');
        }
    },

    //  marquei pra excluir despois pois acho que nao estou usando
    //  async buscarOrdemPorId(idOrdem) {
    //     try {
    //        // console.log('Buscando ordem por ID:', idOrdem);
    //         idOrdem = String(idOrdem).trim();

    //         const url = `${BASE_URL}/liberacao-ordem/${idOrdem}`;
    //        // console.log('URL da requisição:', url);

    //         const response = await api.get(url);

    //         if (response.status === 200) {
    //             return response;
    //         } else {
    //             throw new Error("Erro ao buscar detalhes da ordem.");
    //         }
    //     } catch (error) {
    //         console.error('Erro completo ao buscar ordem:', error);
    //         return { data: {} };
    //     }
    // },

    async buscarStatusPorSetor(idOrdem) {
        try {
           // console.log('Buscando status por setor para ordem:', idOrdem);
            idOrdem = String(idOrdem).trim();

            const url = `${BASE_URL}/ordem/${idOrdem}/status-setores`;
           // console.log('URL da requisição de status:', url);

            const response = await api.get(url);

            if (response.status === 200) {
                return response;
            } else {
                throw new Error("Erro ao buscar status dos setores.");
            }
        } catch (error) {
            console.error('Erro completo ao buscar status dos setores:', error);
            throw error;
        }
    },

    async buscarMovimentacoes(idOrdem) {
        try {
           // console.log('Buscando movimentações para ordem:', idOrdem);
            idOrdem = String(idOrdem).trim();

            const url = `${BASE_URL}/ordem/${idOrdem}/movimentacoes`;
            console.log('URL da requisição de movimentações:', url);

            const response = await api.get(url);

            if (response.status === 200) {
                return response;
            } else {
                throw new Error("Erro ao buscar histórico de movimentações.");
            }
        } catch (error) {
            console.error('Erro completo ao buscar movimentações:', error);
            throw error;
        }
    },

    async buscarPendenciasNaoAutorizadas(idOrdem, setor) {
        try {
         //   console.log('service do front api :', idOrdem, setor);

            const url = `${BASE_URL}/movimentacao-producao/pendencias-nao-autorizadas-setor/${idOrdem}/${setor}`;
            const response = await api.get(url);
            console.log('URL da requisição:', url);

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error("Erro ao buscar pendências não autorizadas.");
            }
        } catch (error) {
            console.error('Erro ao buscar pendências não autorizadas:', error);
            throw error;
        }
    },



// buscar pendencias nao autorizadas por chefe
    async buscarPendenciasNaoAutorizadasPorChefe(idChefe) {
        try {
          //  console.log('service do front api :', idChefe);

            const url = `${BASE_URL}/movimentacao-producao/pendencias-nao-autorizadas-por-chefe/${idChefe}`;
            const response = await api.get(url);
           // console.log('URL da requisição:', url);

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error("Erro ao buscar pendências não autorizadas.");
            }
        } catch (error) {
            console.error('Erro ao buscar pendências não autorizadas:', error);
            throw error;
        }
    },

    async removerMovimentacao(idMovimentacao) {
        try {
           // console.log('Removendo movimentacao:', idMovimentacao);
            const url = `${BASE_URL}/movimentacao-producao/${idMovimentacao}`;
            const response = await api.delete(url);

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error("Erro ao remover movimentacao.");
            }
        } catch (error) {
            console.error('Erro ao remover movimentacao:', error);
            throw error;
        }
    },

    async saldoEtapa(idOrdem, setor) {
        try {

            const url = `${BASE_URL}/movimentacao-producao/saldo-etapa/${idOrdem}/${setor}`;
            const response = await api.get(url);

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error("Erro ao buscar saldo atual.");
            }
        } catch (error) {
            console.error('Erro ao buscar saldo atual:', error);
            throw error;
        }
    },

    async autorizarPendencia(idPendencia, idChefeAutorizou) {
        try {
           // console.log(`Enviando autorização para pendência ${idPendencia} pelo chefe ${idChefeAutorizou}`);
            const url = `${BASE_URL}/movimentacao-producao/autorizar-pendencia/${idPendencia}`;

            // Formata a data atual no formato esperado pelo backend (YYYY-MM-DD HH:MM:SS)
            const agora = new Date();
            const dataFormatada = agora.toISOString().slice(0, 19).replace('T', ' ');

            const data = {
                id_chefe_autorizou: idChefeAutorizou,
                data_autorizacao: dataFormatada
            };

           // console.log('Dados da requisição:', data);
            const response = await api.post(url, data);

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error("Erro ao autorizar pendência.");
            }
        } catch (error) {
            console.error('Erro ao autorizar pendência:', error);
            throw error;
        }
    },

    /**
     * 📊 BUSCAR SALDOS POR ID DE ORDEM
     */
    async buscarSaldosPorOrdem(ordemId) {
        try {
            const url = `${BASE_URL}/movimentacao-producao/saldo-por-id-ordem/${ordemId}`;
            const response = await api.get(url);

           // console.log('📊 Saldos da ordem carregados', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Erro ao buscar saldos da ordem:', error);
            return { status: 'erro', message: error.message };
        }
    },




        // ========================================
    // 🗑️ MÉTODOS PARA EXCLUSÃO DE ORDEM
    // ========================================

    /**
     * 🔍 BUSCAR DETALHES DA ORDEM PARA CONFIRMAR EXCLUSÃO
     */
    async buscarDetalhesParaExclusao(idOrdem) {
        try {
            //  console.log('🔍 Buscando detalhes da ordem para exclusão:', idOrdem);

            const url = `${BASE_URL}/ordem-producao/${idOrdem}/detalhes-exclusao`;
            // console.log('📡 URL da requisição:', url);

            const response = await api.get(url);

            if (response.status === 200 && response.data?.success) {
  //              console.log('✅ Detalhes da ordem carregados para exclusão');
//                console.log('📊 Registros relacionados:', response.data.data.relacionados);

                return {
                    status: 'sucesso',
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao buscar detalhes da ordem');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar detalhes para exclusão:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar detalhes da ordem',
                code: error.response?.status || 500
            };
        }
    },


/**
 * 🗑️ EXCLUIR ORDEM DE PRODUÇÃO COMPLETA
 */
async excluirOrdemCompleta(idOrdem, observacao) {
    try {
        //console.log('🗑️ Excluindo ordem completa:', idOrdem);
        //  ('📝 Observação enviada:', observacao); // ✅ Adicionar log

        const url = `${BASE_URL}/ordem-producao/${idOrdem}/excluir-completa`;
        //console.log('�� URL da requisição de exclusão:', url);

        // ✅ CORREÇÃO: Usar 'data' para enviar no body
        const response = await api.delete(url, {
            data: {
                observacao: observacao
            }
        });

        if (response.status === 200 && response.data?.success) {
                //console.log('✅ Ordem excluída com sucesso');
            //console.log('📊 Total excluído:', response.data.data.total_excluido);

            return {
                status: 'sucesso',
                id_ordem: response.data.data.id_ordem,
                total_excluido: response.data.data.total_excluido,
                registros_excluidos: response.data.data.registros_excluidos,
                message: response.data.message,
                data_exclusao: response.data.data.data_exclusao
            };
        } else {
            throw new Error(response.data?.message || 'Erro na exclusão');
        }
    } catch (error) {
        console.error('❌ Erro ao excluir ordem completa:', error);

        throw {
            status: 'erro',
            message: error.response?.data?.message || error.message || 'Erro ao excluir ordem',
            code: error.response?.status || 500
        };
    }
},

    // 🏁 MÉTODOS PARA FINALIZAÇÃO DE ORDEM
    // ========================================

    /**
     * 🔍 BUSCAR ORDENS PARA FINALIZAÇÃO
     */
    async buscarOrdensParaFinalizacao(params = {}) {
        try {
            //console.log('🔍 Buscando ordens para finalização:', params);

            const url = `${BASE_URL}/ordem-producao/buscar-finalizacao`;
            const response = await api.get(url, { params });

            if (response.status === 200 && response.data?.success) {
               // console.log('✅ Ordens encontradas para finalização');

                return {
                    status: 'sucesso',
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao buscar ordens');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar ordens para finalização:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar ordens',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 🏁 FINALIZAR ORDEM DE PRODUÇÃO (Simplificado)
     */
    async finalizarOrdem(idOrdem, dataFinalizacao) {
        try {
           // console.log('🏁 Finalizando ordem de produção:', idOrdem, 'Data finalização:', dataFinalizacao);

            const url = `${BASE_URL}/ordem-producao/${idOrdem}/finalizar`;
            const response = await api.put(url, {
                data_finalizacao: dataFinalizacao
            });

            if (response.status === 200 && response.data?.success) {
               // console.log('✅ Ordem finalizada com sucesso');

                return {
                    status: 'sucesso',
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao finalizar ordem');
            }
        } catch (error) {
            console.error('❌ Erro ao finalizar ordem:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao finalizar ordem',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📊 BUSCAR DETALHES COMPLETOS DA ORDEM PARA FINALIZAÇÃO
     */
    async buscarDetalhesParaFinalizacao(idOrdem) {
        try {
           // console.log('📊 Buscando detalhes da ordem para finalização:', idOrdem);

            const url = `${BASE_URL}/ordem-producao/${idOrdem}/detalhes-finalizacao`;
            const response = await api.get(url);

            if (response.status === 200 && response.data?.success) {
               // console.log('✅ Detalhes da ordem carregados para finalização');

                return {
                    status: 'sucesso',
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao buscar detalhes da ordem');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar detalhes para finalização:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar detalhes da ordem',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📋 LISTAR LOG DE EXCLUSÕES
     */
    async listarLogExclusoes(filtros = {}) {
        try {
            //console.log('📋 Buscando log de exclusões com filtros:', filtros);

            const params = new URLSearchParams();

            if (filtros.usuario) params.append('usuario', filtros.usuario);
            if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
            if (filtros.data_fim) params.append('data_fim', filtros.data_fim);

            const url = `${BASE_URL}/ordem-producao/log-exclusoes`;
            const fullUrl = params.toString() ? `${url}?${params.toString()}` : url;

            //console.log('📡 URL da requisição de log:', fullUrl);

            const response = await api.get(fullUrl);

            if (response.status === 200 && response.data?.success) {
                //console.log('✅ Log de exclusões carregado');
                console.log('📊 Total de registros:', response.data.data.total);

                return {
                    status: 'sucesso',
                    logs: response.data.data.data,
                    pagination: {
                        current_page: response.data.data.current_page,
                        last_page: response.data.data.last_page,
                        per_page: response.data.data.per_page,
                        total: response.data.data.total
                    }
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao buscar log');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar log de exclusões:', error);

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar log de exclusões',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 🔍 VERIFICAR SE ORDEM PODE SER EXCLUÍDA
     */
    async verificarPodeExcluirOrdem(idOrdem) {
        try {
            //console.log('🔍 Verificando se ordem pode ser excluída:', idOrdem);

            // Primeiro busca os detalhes para verificar dependências
            const detalhes = await this.buscarDetalhesParaExclusao(idOrdem);

            if (detalhes.status === 'sucesso') {
                const { relacionados } = detalhes;
                const totalRelacionados = relacionados.total;

                console.log('�� Total de registros relacionados:', totalRelacionados);

                // Definir regras de negócio para exclusão
                const podeExcluir = true; // Por enquanto sempre pode excluir
                const avisos = [];

                if (relacionados.liberacoes > 0) {
                    avisos.push(`${relacionados.liberacoes} liberação(ões) de funcionário serão excluídas`);
                }

                if (relacionados.movimentacoes > 0) {
                    avisos.push(`${relacionados.movimentacoes} movimentação(ões) de produção serão excluídas`);
                }

                if (relacionados.partes > 0) {
                    avisos.push(`${relacionados.partes} parte(s) da ordem serão excluídas`);
                }

                return {
                    status: 'sucesso',
                    pode_excluir: podeExcluir,
                    total_registros: totalRelacionados + 1, // +1 pela própria ordem
                    avisos: avisos,
                    detalhes: detalhes.data
                };
            } else {
                throw new Error('Erro ao verificar dependências da ordem');
            }
        } catch (error) {
            console.error('❌ Erro ao verificar se pode excluir ordem:', error);

            return {
                status: 'erro',
                pode_excluir: false,
                message: error.message || 'Erro ao verificar dependências da ordem'
            };
        }
    },

    /**
     * 📊 BUSCAR ESTATÍSTICAS DE EXCLUSÕES
     */
    async buscarEstatisticasExclusoes() {
        try {
            //console.log('📊 Buscando estatísticas de exclusões...');

            const url = `${BASE_URL}/ordem-producao/estatisticas-exclusoes`;
            const response = await api.get(url);

            if (response.status === 200 && response.data?.success) {
                //console.log('✅ Estatísticas de exclusões carregadas');

                return {
                    status: 'sucesso',
                    estatisticas: response.data.data || {}
                };
            } else {
                throw new Error(response.data?.message || 'Erro ao buscar estatísticas');
            }
        } catch (error) {
            console.error('❌ Erro ao buscar estatísticas de exclusões:', error);

            // Se a rota não existir, retornar dados vazios
            if (error.response?.status === 404) {
                return {
                    status: 'sucesso',
                    estatisticas: {
                        total_exclusoes: 0,
                        exclusoes_mes_atual: 0,
                        usuarios_mais_ativos: [],
                        tipos_mais_excluidos: []
                    }
                };
            }

            throw {
                status: 'erro',
                message: error.response?.data?.message || error.message || 'Erro ao buscar estatísticas',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * 📝 ATUALIZAR OBSERVAÇÃO DE UMA MOVIMENTAÇÃO EXISTENTE
     */
    async atualizarObservacaoMovimentacao(idMovimentacao, observacao) {
        try {
            const url = `${BASE_URL}/movimentacao-producao/${idMovimentacao}/atualizar-observacao`;
            const response = await api.patch(url, { observacao });

            if (response.status === 200 && response.data) {
                return {
                    status: response.data.status || 'sucesso',
                    mensagem: response.data.mensagem || 'Observação atualizada com sucesso!',
                    data: response.data.data
                };
            } else {
                throw new Error('Erro ao atualizar observação');
            }
        } catch (error) {
            console.error('❌ Erro ao atualizar observação:', error);
            throw {
                status: 'erro',
                mensagem: error.response?.data?.mensagem || error.message || 'Erro ao atualizar observação',
                code: error.response?.status || 500
            };
        }
    },

    /**
     * ✍️ CRIAR NOVA OBSERVAÇÃO SEM MOVIMENTAR PEÇAS
     * Usa a tabela ordem_observacoes
     */
    async criarObservacaoSimples(dadosObservacao) {
        try {
            // ✅ ENDPOINT CORRETO: ordem-observacoes/criar-livre
            const url = `${BASE_URL}/ordem-observacoes/criar-livre`;
            
            // ✅ PAYLOAD CORRETO: id_ordem, id_chefe, observacao
            const payload = {
                id_ordem: dadosObservacao.id_ordem_cadastro || dadosObservacao.id_ordem,
                id_chefe: dadosObservacao.id_chefe_cadastro || dadosObservacao.id_chefe,
                observacao: dadosObservacao.observacao
            };
            
            const response = await api.post(url, payload);

            if (response.status === 201 && response.data) {
                return {
                    status: response.data.status || 'sucesso',
                    mensagem: response.data.mensagem || 'Observação criada com sucesso!',
                    data: response.data.data
                };
            } else {
                throw new Error('Erro ao criar observação');
            }
        } catch (error) {
            console.error('❌ Erro ao criar observação:', error);
            throw {
                status: 'erro',
                mensagem: error.response?.data?.mensagem || error.message || 'Erro ao criar observação',
                code: error.response?.status || 500
            };
        }
    },


};

// ========================================
// 🛠️ FUNÇÃO AUXILIAR PARA TRATAMENTO DE ERROS
// ========================================

function handleError(error, mensagemPadrao) {
    if (error.response) {
        // Erro com resposta do servidor
        const status = error.response.status;
        const data = error.response.data;

        switch (status) {
            case 404:
                throw new Error("Recurso não encontrado.");
            case 401:
                throw new Error("Acesso não autorizado. Faça login novamente.");
            case 403:
                throw new Error("Você não tem permissão para esta operação.");
            case 422:
                // Erro de validação - tentar extrair mensagem específica
                const validationMessage = data?.message || data?.mensagem ||
                    (data?.errors ? Object.values(data.errors).flat().join(', ') : null);
                throw new Error(validationMessage || "Dados inválidos fornecidos.");
            case 429:
                throw new Error("Muitas tentativas. Tente novamente em alguns minutos.");
            case 500:
                throw new Error("Erro interno do servidor. Tente novamente mais tarde.");
            case 502:
            case 503:
            case 504:
                throw new Error("Servidor temporariamente indisponível. Tente novamente.");
            default:
                throw new Error(data?.message || data?.mensagem || mensagemPadrao);
        }
    } else if (error.request) {
        // Erro de rede - sem resposta do servidor
        throw new Error("Erro de rede. Verifique sua conexão com a internet.");
    } else {
        // Erro na configuração da requisição
        throw new Error(error.message || mensagemPadrao);
    }
}

export default producaoService;
